export default class AccordionSection {
	constructor(el = null) {
		if (!el) return;
		this.section = el;
		this.items = Array.from(this.section.querySelectorAll('.accordion-item'));
		if (!this.items || this.items.length === 0) return;
		this.buttons = Array.from(this.section.querySelectorAll('.accordion-button'));
		this.events();
	}

	onButtonClick(ev) {
		const btn = ev.currentTarget;
		btn.closest(".accordion-item").querySelector(".content").classList.toggle('show', btn.checked);
	}
	events() {
		Array.from(this.buttons).map(btn => btn.addEventListener('click', this.onButtonClick.bind(this), false));
	}
}
